import { Box, Button, Grid, Typography } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useEmployeeContext } from '../../../Contexts/Providers/EmployeeLayoutProvider';

export interface IAfterActionScreenProps {
    onAction1Click?: () => void;
    onAction2Click?: () => void;
    action1Text: string;
    action2Text: string;
    action1Icon: JSX.Element;
    action2Icon: JSX.Element;
    title: string;
    message: string;
    customMessage?: JSX.Element;
    icon: JSX.Element;
}

export default function AfterActionScreen(props: IAfterActionScreenProps) {
    const { t } = useTranslation();
    const { setMenuHidden } = useEmployeeContext()
    const { onAction1Click, onAction2Click, action1Text, action2Text, action1Icon, action2Icon, title, message, customMessage, icon } = props;
    const [beforeTime, time] = message.split(' ');
    return (
        <Grid
            container
            direction="column"
            sx={{ height: 'calc(100vh - 56px)', display: 'flex' }}
        >
            <Grid
                item
                xs
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexGrow: 1 }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 1
                    }}
                >
                    {React.cloneElement(icon, { sx: { height: 90, width: 90, color: '#FFC600' } })}
                    <Typography sx={{ fontSize: 24, fontWeight: 'bold', textAlign: 'center' }}>
                        {t(title)}
                    </Typography>
                    {customMessage ?
                        customMessage :
                        <Typography sx={{ fontSize: 18, color: '#77767B' }} component="span">
                            {t(beforeTime) + ' '}
                            <span style={{ fontWeight: 'bold', color: 'black' }}>{time}</span>
                        </Typography>
                    }
                </Box>
            </Grid>
            <Grid
                item
                xs="auto"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 1,
                    mb: 2,
                    mx: 2
                }}
            >
                <Button
                    variant="contained"
                    fullWidth
                    sx={{
                        background: 'black', color: 'white', borderRadius: 6, py: 1.5
                        , '&:hover': { background: 'black' }
                    }}
                    onClick={() => {
                        if (onAction1Click) {
                            onAction1Click();
                        }
                        setMenuHidden && setMenuHidden(false);
                    }}
                >
                    <Box
                        sx={{
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: 18,
                                fontWeight: 'bold',
                                textTransform: 'initial'
                            }}
                        >
                            {t(action1Text)}
                        </Typography>
                        {React.cloneElement(action1Icon, { sx: { height: 32, width: 32 } })}
                    </Box>
                </Button>
                <Button
                    variant="contained"
                    fullWidth
                    sx={{ borderRadius: 6, py: 1.5 }}
                    onClick={() => {
                        if (onAction2Click) {
                            onAction2Click();
                        }
                        setMenuHidden && setMenuHidden(false);
                    }}
                >
                    <Box
                        sx={{
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: 18,
                                fontWeight: 'bold',
                                textTransform: 'initial'
                            }}
                        >
                            {t(action2Text)}
                        </Typography>
                        {React.cloneElement(action2Icon, { sx: { height: 32, width: 32 } })}
                    </Box>
                </Button>
            </Grid>
        </Grid>

    );
}
